<template>
  <div>
    <!-- define an error snackbar -->
    <v-snackbar v-model="registrationLoading">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn color="pink" text v-bind="attrs"> Cerrar </v-btn>
      </template>
    </v-snackbar>

    <!-- define the page title -->
    <v-row class="text-center">
      <v-col cols="12" class="mt-4 mb-4">
        <h1 class="font-weight-bold mb-3 ifont ma-2">
          Registrador de DID: Identidad digital universal
        </h1>
        <p class="ifont ma-4">
          Esta aplicación te permite crear y registrar un DID en tan solo 2
          pasos.
        </p>
      </v-col>
    </v-row>

    <!--define the steppers -->
    <v-container class="center">
      <v-row align="center" justify="center" class="center block-size">
        <v-col cols="12" class="mt-4 mb-4 center">
          <v-stepper v-model="e1">
            <v-stepper-header>
              <v-stepper-step :complete="e1 > 1" step="1" color="#ff5000">
                Crear DID
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="e1 > 2" step="2" color="#ff5000">
                Registrar DID
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step step="3" color="#ff5000">
                Resultado
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card elevation="0" class="mb-0">
                  <v-card-text>
                    <!-- define the main did registration form -->
                    <v-row align="center" justify="center">
                      <v-card elevation="0">
                        <v-card-title class="ifont pt-0 pb-1"
                          >Modo estándar</v-card-title
                        >
                        <v-card-text class="text-right">
                          <p class="ifont" style="text-align: justify">
                            Esta es la forma más sencilla de obtener tu DID,
                            aunque existen riesgos asociados a generar
                            información privada en un servidor.
                          </p>
                          <v-btn
                            outlined
                            color="#ff5000"
                            @click="onStandardRegistrationRequest"
                          >
                            Obtener DID
                          </v-btn>
                        </v-card-text>

                        <v-card-title class="ifont pt-0 pb-1"
                          >Modo experto</v-card-title
                        >
                        <v-card-text class="text-right">
                          <p class="ifont" style="text-align: justify">
                            Para crear tu DID de la forma más segura, te
                            ayudamos con tres lenguajes (NodeJS, Golang,
                            Python). Ejecuta el script en tu entorno local y
                            guarda para el siguiente paso la información de la
                            respuesta.
                          </p>

                          <div class="js-block">
                            <v-tabs
                              v-model="tab"
                              align-with-title
                              fixed-tabs
                              light
                              class="bar-color"
                              @change="repaintCode"
                            >
                              <v-tabs-slider color="#ff5000"></v-tabs-slider>
                              <v-tab class="black--text">NodeJS</v-tab>
                              <v-tab class="black--text">Go</v-tab>
                              <v-tab class="black--text">Python</v-tab>
                            </v-tabs>

                            <v-tabs-items v-model="tab">
                              <v-tab-item>
                                <keep-alive>
                                  <prism-editor
                                    class="my-editor"
                                    v-model="nodejs"
                                    :highlight="highlighter"
                                    readonly
                                  ></prism-editor>
                                </keep-alive>
                              </v-tab-item>
                              <v-tab-item>
                                <keep-alive>
                                  <prism-editor
                                    class="my-editor"
                                    v-model="gocode"
                                    :highlight="highlighter"
                                    readonly
                                  ></prism-editor>
                                </keep-alive>
                              </v-tab-item>
                              <v-tab-item>
                                <keep-alive>
                                  <prism-editor
                                    class="my-editor"
                                    v-model="pythoncode"
                                    :highlight="highlighter"
                                    readonly
                                  ></prism-editor>
                                </keep-alive>
                              </v-tab-item>
                            </v-tabs-items>
                          </div>
                        </v-card-text>
                      </v-card>
                    </v-row>
                  </v-card-text>
                </v-card>

                <div class="text-right mr-5 mb-2">
                  <v-btn outlined color="#ff5000" @click="showFormView">
                    {{ buttonText }}
                  </v-btn>
                </div>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card elevation="0" class="mb-12">
                  <v-card-text>
                    <!-- define the main did registration form -->
                    <v-row align="center" justify="center">
                      <v-card elevation="0">
                        <v-card-title class="ifont"
                          >Registra tu DID</v-card-title
                        >
                        <v-card-subtitle
                          class="ifont"
                          style="text-align: justify"
                          >En este paso se registra tu DID con el rol de
                          ENDORSER en la red seleccionada. Para ello, introduce
                          la información de la respuesta del paso anterior.
                        </v-card-subtitle>
                        <v-card-text>
                          <v-form
                            v-model="form.valid"
                            ref="registrarForm"
                            lazy-validation
                          >
                            <v-container>
                              <v-row>
                                <v-col cols="12" sm="12" md="12" class="nop">
                                  <v-text-field
                                    outlined
                                    color="#ff5000"
                                    label="DID"
                                    hint="Tu DID creado"
                                    v-model="request.did"
                                    required
                                    counter
                                    :rules="form.rules.didRules"
                                    maxlength="22"
                                    minlength="22"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" md="12" class="nop">
                                  <v-text-field
                                    outlined
                                    color="#ff5000"
                                    label="VERKEY"
                                    hint="Tu VERKEY creada"
                                    v-model="request.verkey"
                                    required
                                    counter
                                    :rules="form.rules.verkeyRules"
                                    maxlength="44"
                                    minlength="44"
                                  ></v-text-field>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-form>
                        </v-card-text>
                      </v-card>
                    </v-row>
                  </v-card-text>
                </v-card>

                <v-btn
                  outlined
                  color="#ff5000"
                  @click="validateFormAndSubmit"
                  :loading="registrationLoading"
                  class="ma-1"
                >
                  {{ buttonText }}
                </v-btn>

                <v-btn text @click="onCancel" class="ma-1">
                  Ir al paso anterior
                </v-btn>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-card class="mb-0" elevation="0" width="auto">
                  <v-card-text>
                    <!-- define the main did registration form -->
                    <v-row align="center" justify="center">
                      <v-card elevation="0">
                        <v-card-title class="ifont" style="text-align: center"
                          >Resultado del registro</v-card-title
                        >
                        <v-card-text>
                          <v-alert
                            v-if="$store.getters.registrationSuccess"
                            type="success"
                            dense
                            text
                          >
                            DID registrado correctamente
                          </v-alert>
                          <v-alert v-else type="error" dense text>
                            Ocurrió un error al registrar el DID
                          </v-alert>

                          <p
                            v-if="$store.getters.registrationSuccess"
                            class="text-left"
                          >
                            <strong>
                              Detalle de los datos asociados al registro de tu
                              DID. Guárdalos en un lugar seguro.
                            </strong>
                          </p>

                          <prism-editor
                            class="my-editor rounded-card"
                            v-model="response"
                            :highlight="highlighter"
                            readonly
                          ></prism-editor>
                        </v-card-text>
                      </v-card>
                    </v-row>
                  </v-card-text>
                </v-card>
                <v-btn
                  outlined
                  color="#ff5000"
                  @click="copyData"
                  class="mr-3 ma-1"
                >
                  Copiar JSON
                </v-btn>
                <v-btn outlined color="#ff5000" class="ma-1" @click="e1 = 1">
                  Ir al inicio
                </v-btn>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// import Prism Editor
import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css"; // import the styles somewhere

// import highlighting library (you can use any library you want just return html string)
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-tomorrow.css"; // import syntax highlighting styles

const nodejs = `const indy = require('indy-sdk');

const walletConfig = {id: "tu-id"};
const walletCredentials = {key: "tu-p4ssw00rd"};

await indy.createWallet(walletConfig, walletCredentials);

const wh = await indy.openWallet(walletConfig, walletCredentials);
const [theirDid, theirVerkey] = await indy.createAndStoreMyDid(wh, {});`;

const gocode = `package main

func main(){
  u, err := CreateUser("user")
  if err != nil {
    panic(err.Error())
  }

  didObj, crErr := u.CreateDid(nil)
  if crErr != nil {
    panic(crErr.Error())
  }
  fmt.Println(didObj.Did, didObj.Verkey)
}`;

const pythoncode = `from indy import error
from indy import did

(_did, ver_key) = await did.create_and_store_my_did(wallet_handle, "{}")`;

export default {
  name: "Indy-Register-Did-Form",
  data: () => ({
    nodejs,
    gocode,
    pythoncode,
    e1: 1,
    tab: undefined,
    buttonNames: ["Continuar", "Registrar", "Comprobar"],
    snackbar: {
      visible: false,
      text: "",
    },
    checkbox: false,
    request: {
      create: false,
      did: undefined,
      verkey: undefined,
    },
    form: {
      valid: false,
      rules: {
        didRules: [
          (v) => !!v || "El DID es obligatorio",
          (v) =>
            (v && v.length == 22) ||
            "La longitud del DID introducido no es valido",
        ],
        verkeyRules: [
          (v) => !!v || "La VERKEY es obligatoria",
          (v) =>
            (v && v.length == 44) ||
            "La longitud de la VERKEY introducida no es valida",
        ],
      },
    },
  }),
  watch: {
    tab: function () {
      this.repaintCode();
    },
    registrationLoading: function (newVal) {
      if (newVal == false) {
        // registration request end, so we can move to next tab
        this.e1 = 3;
      }
    },
  },
  computed: {
    registrationLoading: function () {
      return this.$store.getters.registrationPending;
    },
    buttonText: function () {
      return this.buttonNames[this.e1 - 1];
    },
    response: function () {
      const data = this.$store.getters.registrationResponse;
      console.log(data);
      return JSON.stringify(data, null, "\t");
    },
  },
  methods: {
    repaintCode: function () {
      this.$forceUpdate();
    },
    onCancel: function () {
      this.e1 = 1;
    },
    showFormView: function () {
      this.request.create = false;
      this.e1 = 2;
    },
    onStandardRegistrationRequest: function () {
      this.request.create = true;
      this.submitRegistration();
    },
    validateFormAndSubmit: function () {
      if (this.$refs.registrarForm.validate()) {
        this.submitRegistration();
      }
    },
    submitRegistration: function () {
      // trigger the submission
      this.$store.dispatch("registerDid", this.request);
      // show toast
      this.snackbar.visible = true;
      this.snackbar.text = "Registrando información...";
    },
    highlighter(code) {
      return highlight(code, languages.js); // languages.<insert language> to return html with markup
    },
    copyData: function () {
      this.copyTextToClipboard(this.response);
    },
    fallbackCopyTextToClipboard: function (text) {
      var textArea = document.createElement("textarea");
      textArea.value = text;

      // Avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "successful" : "unsuccessful";
        console.log("Fallback: Copying text command was " + msg);
      } catch (err) {
        console.error("Fallback: Oops, unable to copy", err);
      }

      document.body.removeChild(textArea);
    },
    copyTextToClipboard: function (text) {
      if (!navigator.clipboard) {
        this.fallbackCopyTextToClipboard(text);
        return;
      }
      navigator.clipboard.writeText(text).then(
        function () {
          console.log("async: Copying to clipboard was successful!");
        },
        function (err) {
          console.error("async: Could not copy text: ", err);
        }
      );
    },
  },
  components: {
    PrismEditor,
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=IBM+Plex+Mono&display=swap");
.ifont {
  font-family: "Shippori Antique", sans-serif !important;
}
.nop {
  padding: 0px;
  margin: 0px;
}
.center {
  text-align: center !important;
  text-align: -moz-center !important;
  text-align: -webkit-center !important;
}
.left {
  text-align: left;
}
pre,
code,
.prism-editor-wrapper .prism-editor__container {
  font-size: 16px !important;
  color: #e6e6e6;
  background-color: #1c1c1c !important;
  font-family: "IBM Plex Mono", monospace !important;
  margin-left: 20px;
  margin: 0px;
  padding: 7px !important;
  box-shadow: 0px 0px 17px #b5b5b5;
}

.rounded-card {
  box-shadow: 0px 0px 20px #938989;
  border-radius: 14px;
}

.v-application code,
code {
  padding: 0px;
}

pre {
  margin: 15px;
}

.js-block {
  border-width: 2px;
  border-color: #ff5000;
  border-style: solid;
}
.tcn-color {
  color: #ff5000;
}
.v-stepper__header {
  box-shadow: none;
}
.v-sheet.v-card {
  border-radius: 4px;
  width: 100%;
}
.block-size {
  max-width: 900px;
}
.v-input--selection-controls .v-input__slot > .v-label,
.v-input--selection-controls .v-radio > .v-label {
  text-align: justify;
}
</style>

<style>
.v-tabs-bar {
  background-color: #ff50001f !important;
}
pre,
code,
.prism-editor-wrapper .prism-editor__container {
  font-size: 16px !important;
  background-color: #1c1c1c !important;
  font-family: "IBM Plex Mono", monospace !important;
  color: #d9d9d9;
  margin-left: 20px;
  margin: 0px;
  padding: 7px !important;
}
</style>

<style>
/**
* xonokai theme for JavaScript, CSS and HTML
* based on: https://github.com/MoOx/sass-prism-theme-base by Maxime Thirouin ~ MoOx --> http://moox.fr/ , which is Loosely based on Monokai textmate theme by http://www.monokai.nl/
* license: MIT; http://moox.mit-license.org/
*/
code[class*="language-"],
pre[class*="language-"] {
  -moz-tab-size: 2;
  -o-tab-size: 2;
  tab-size: 2;
  -webkit-hyphens: none;
  -moz-hyphens: none;
  -ms-hyphens: none;
  hyphens: none;
  white-space: pre;
  white-space: pre-wrap;
  word-wrap: normal;
  font-family: Menlo, Monaco, "Courier New", monospace;
  font-size: 14px;
  color: #76d9e6;
  text-shadow: none;
}

pre > code[class*="language-"] {
  font-size: 1em;
}

pre[class*="language-"],
:not(pre) > code[class*="language-"] {
  background: #2a2a2a;
}

pre[class*="language-"] {
  padding: 15px;
  border-radius: 4px;
  border: 1px solid #e1e1e8;
  overflow: auto;
  position: relative;
}

pre[class*="language-"] code {
  white-space: pre;
  display: block;
}

:not(pre) > code[class*="language-"] {
  padding: 0.15em 0.2em 0.05em;
  border-radius: 0.3em;
  border: 0.13em solid #7a6652;
  box-shadow: 1px 1px 0.3em -0.1em #000 inset;
}

.token.namespace {
  opacity: 0.7;
}

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: #6f705e;
}

.token.operator,
.token.boolean,
.token.number {
  color: #a77afe;
}

.token.attr-name,
.token.string {
  color: #e6d06c;
}

.token.entity,
.token.url,
.language-css .token.string,
.style .token.string {
  color: #e6d06c;
}

.token.selector,
.token.inserted {
  color: #a6e22d;
}

.token.atrule,
.token.attr-value,
.token.keyword,
.token.important,
.token.deleted {
  color: #ef3b7d;
}

.token.regex,
.token.statement {
  color: #76d9e6;
}

.token.placeholder,
.token.variable {
  color: #fff;
}

.token.important,
.token.statement,
.token.bold {
  font-weight: bold;
}

.token.punctuation {
  color: #bebec5;
}

.token.entity {
  cursor: help;
}

.token.italic {
  font-style: italic;
}

code.language-markup {
  color: #f9f9f9;
}

code.language-markup .token.tag {
  color: #ef3b7d;
}

code.language-markup .token.attr-name {
  color: #a6e22d;
}

code.language-markup .token.attr-value {
  color: #e6d06c;
}

code.language-markup .token.style,
code.language-markup .token.script {
  color: #76d9e6;
}

code.language-markup .token.script .token.keyword {
  color: #76d9e6;
}

/* Line highlight plugin */
.line-highlight.line-highlight {
  padding: 0;
  background: rgba(255, 255, 255, 0.08);
}

.line-highlight.line-highlight:before,
.line-highlight.line-highlight[data-end]:after {
  padding: 0.2em 0.5em;
  background-color: rgba(255, 255, 255, 0.4);
  color: black;
  height: 1em;
  line-height: 1em;
  box-shadow: 0 1px 1px rgba(255, 255, 255, 0.7);
}
</style>